module.exports = __webpack_public_path__ + "static/4-397faff4c7f3b4beb4067ee856b1532b.jpg";